import * as z from "zod";

export const timeZoneSchema = z
	.string()
	.min(1)
	.max(64)
	.regex(/^[A-Za-z0-9_+/-]+$/);
